import axios from "axios";

const BASE_URL = "https://backre-miami.us-3.evennode.com";

// ✅ GET: Traer todos los colores
export const getColores = async () => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/colores`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });

    return resp.data;
  } catch (error) {
    console.error("❌ Error al obtener colores:", error.response?.data || error);

    return {
      ok: false,
      error: error.response?.data || "Error al obtener colores",
    };
  }
};

// ✅ GET: Traer un color por ID
export const getColorId = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/colores/${id}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });

    return resp.data;
  } catch (error) {
    console.error("❌ Error al obtener color:", error.response?.data || error);

    return {
      ok: false,
      error: error.response?.data || "Error al obtener el color",
    };
  }
};

// ✅ POST: Crear nuevo color
export const postColor = async (colorData) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/colores`;

  console.log("📤 Enviando color:", colorData);

  try {
    const resp = await axios.post(url, colorData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });

    return resp.data;
  } catch (error) {
    console.error("❌ ERROR COMPLETO POST COLOR:", error);
    console.error(
      "❌ RESPUESTA BACKEND POST:",
      JSON.stringify(error.response?.data, null, 2)
    );

    return {
      ok: false,
      error: error.response?.data || "Error al crear color",
    };
  }
};

// ✅ PUT: Actualizar color
export const putColor = async (id, colorData) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/colores/${id}`;

  console.log("📤 Modificando color:", id, colorData);

  try {
    const resp = await axios.put(url, colorData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });

    return resp.data;
  } catch (error) {
    console.error("❌ ERROR COMPLETO PUT COLOR:", error);
    console.error(
      "❌ RESPUESTA BACKEND PUT:",
      JSON.stringify(error.response?.data, null, 2)
    );

    alert(
      "Error backend PUT: " +
        JSON.stringify(error.response?.data, null, 2)
    );

    return {
      ok: false,
      error: error.response?.data || "Error al actualizar color",
    };
  }
};

// ✅ DELETE: Desactivar o eliminar color
export const deleteColor = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/colores/${id}`;

  try {
    const resp = await axios.delete(url, {
      headers: { token },
    });

    return resp.data;
  } catch (error) {
    console.error("❌ Error al eliminar color:", error.response?.data || error);

    return {
      ok: false,
      error: error.response?.data || "Error al eliminar color",
    };
  }
};